module.exports = __webpack_public_path__ + "static/media/ico-floating-vendors-active.7a42816c.svg";